import type { QuoteFile, PresentationLibrary } from 'paintscout'
import { addFilesToLibrary } from './add-files-to-library'

export interface SelectNewLibraryFilesResult {
  selected: QuoteFile
  updatedLibrary: PresentationLibrary | null
}

/**
 * Adds every file in `newFiles` to the library in one save — so a multi-file drop/upload
 * made while filling a single slot doesn't silently drop anything past the first — and
 * reports which one should be selected into that slot (always the first).
 */
export const selectNewLibraryFiles = (args: {
  newFiles: QuoteFile[]
  library: PresentationLibrary
}): SelectNewLibraryFilesResult | null => {
  const { newFiles, library } = args
  const [selected] = newFiles
  if (!selected) return null

  return {
    selected,
    updatedLibrary: addFilesToLibrary({ files: newFiles, library })
  }
}
